<script>
  const posts = [];
  import { support_email } from "$/client/config.js";
</script>

<style>
  footer {
    display: flex;
    min-height: var(--fixed-footer-height);
    padding: 1rem;
  }

  footer a {
    color: var(--color-text-header);
  }

  footer > column {
    display: flex;
    flex-direction: column;
    padding: 1rem;
  }

  footer > column h5 {
    margin: 0px;
  }

  @media only screen and (max-width: 800px) {
    footer {
      flex-direction: column;
    }
  }
</style>

<footer>
  <column>
  <a id="logo" href="/">LCTHW</a>

  <p>
    Shavian Publishing, LLC.
    The Pre-Beginner Education Company
  </p>

  <span><a href="https://twitter.com/lzsthw">follow me @lzsthw</a></span>

  <p>Copyright &copy; 2020-2022. Zed A. Shaw. All Rights Reserved.</p>
  </column>
  <column>
  <h5>COMPANY</h5>

  <ol>
    <li><a href="https://shop.learncodethehardway.org/">PRODUCT</a></li>
    <li><a href="mailto:help@learncodethehardway.org">help@learncodethehardway.org</a></li>
  </ol>
  </column>

  <column>
  <h5>RESOURCES</h5>

  <ol>
    <li><a href="/posts/">BLOG</a></li>
  </ol>

  </column>

  <column>
  <h5>RECENT POSTS</h5>

  <ol>
    {#each posts.slice(0, 10) as post}
      <li><a href="/posts/{post.metadata.slug}/">{post.metadata.title}</a></li>
    {/each}
  </ol>
  </column>
</footer>
